import api from '../baseApi.js'
import { unwrap } from '../helpers.js'

export const subscriptionApi = {
  get: () => api.get('/subscription').then(unwrap),
  getPlans: () => api.get('/subscription/plans').then(unwrap),
  startTrial: () => api.post('/subscription/trial').then(unwrap),
  createOrder: (data) => api.post('/subscription/order', data).then(unwrap),
  verifyPayment: (data) => api.post('/subscription/verify', data).then(unwrap),
  createRecurring: (data) => api.post('/subscription/recurring', data).then(unwrap),
  verifyRecurring: (data) => api.post('/subscription/recurring/verify', data).then(unwrap),
  cancelAutoRenew: () => api.post('/subscription/cancel-auto-renew').then(unwrap),
}
